import { render, staticRenderFns } from "./pause-round.vue?vue&type=template&id=56773cac&scoped=true&"
import script from "./pause-round.vue?vue&type=script&lang=js&"
export * from "./pause-round.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56773cac",
  null
  
)

export default component.exports